import React, { useState, useEffect } from "react";
import {
  Container,
  Stack,
} from "@mui/material";
import { API_Subscriber, APIs_profile } from "./api.jsx";
import { ftchPlus, getOptions, putOptions } from "./Account_urls.jsx";
import CardCommon from "./CardCommon.jsx";
import Subscribe from "./Subscribe.jsx";
import ProfilePreferences from "./ProfilePreferences.jsx";
import ProfileData from "./ProfileData.jsx";
import { ErrorBar } from "../Components/ErrorBar.jsx";
import { Help_Profile } from "../Dialogs/Help/Help_Profile.jsx";
// import { PdfBuild } from "../Dialogs/Pdf/Export.jsx";
import { useAuth } from "./useAuth.jsx";

const ProfileInput = ({ open, onClose }) => {
  const { admin_r } = useAuth();
  const [admin] = useState(admin_r.current)
  const [errmsg, setErrmsg] = useState("")
  const [errmsg_s, setErrmsg_s] = useState("")

  const [form, setForm] = useState();
  const [openSubscription, setOpenSubscription] = useState(false);
  const [openPreferences, setOpenPreferences] = useState(false);
  // const [openPDFBuild, setOpenPDFBuild] = useState(false);
  const [openData, setOpenData] = useState(false);

  const getInputData = () => {
    var url = API_Subscriber + APIs_profile;
    console.log(url)
    ftchPlus(url, getOptions)
      .then((json) => {
        if (json) {
          setForm({
            ...json,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };


  const postPreferences = () => {
    var url = API_Subscriber + APIs_profile;
    console.log(url)
    var req = putOptions;
    req.body = JSON.stringify(form);
    ftchPlus(url, req)
      .then((json) => {
        console.log(json);
        onClosePreferences()
      })
      .catch((error) => {
        console.log(error);
        setErrmsg_s("Store failed: alias is taken.")
      });
  };
  useEffect(() => {
    setErrmsg_s("")
    console.log(open)
    if (open) {
      getInputData();
    }
  }, [open]);

  const onChange = (pref) => {
    let nf = {
      ...form,
      ["preferences"]: pref
    }
    setForm(nf)
  }

  const onSubmit = () => {
    postPreferences()

  };

  const subBasic = () => {
    let s = ""
    if (form) {
      s = "Name: " + form.name + "<br />"
      s += "Email: " + form.email + "<br />"
      s += "Created: " + form.created + "<br />"
    }
    return s
  };

  const subCredentials = () => {
    let s = ""
    if (form) {
      s = "Auth: " + form.auth.by + "<br />"
      s += "AuthName: " + form.auth.name + "<br />"
    }
    return s
  }
  const subSubscriptions = () => {
    let s = ""
    if (form) {
      if (form.product && form.product.length > 0) {
        form.product.forEach(sub => {

          s = sub.name + "<br />"
          s += "&emsp;  Tier: " + sub.level + "<br />"
          s += "&emsp;  Expires: " + sub.expiry + "<br />"
          s += "&emsp;  Quantity: " + sub.quantity + "(" + sub.count + ")<br />"
        });
      }
      if (s === "") {
        s = "None"
      }
    } else {
      s = "None"
    }
    return s
  }

  const subTier = () => {
    let t = ""
    if (form.product && form.product.length > 0) {
      form.product.forEach(sub => {
        console.log(sub.level)
        t = sub.level
      })
    }
    return t

  }
  const subCount = () => {
    let count = 0
    if (form.product && form.product.length > 0) {
      form.product.forEach(sub => {
        count = sub.quantity
      })
    }
    return count

  }

  const subStatistics = () => {
    let s = ""
    if (form) {
      if (form.stats.Stat && form.stats.Stat.length > 0) {
        form.stats.Stat.forEach(sub => {

          s = sub + "<br />"

        });
      }
      if (s === "") {
        s = "None"
      }
    } else {
      s = "None"
    }
    return s
  }


  const subPreferences = () => {
    let s = ""
    if (form) {
      s = "Alias: " + form.preferences.Alias + "<br />"
      s += "Grid Round: " + form.preferences.GridRound + "<br />"
      s += "Startup Help: " + form.preferences.StartupHelp + "<br />"
      s += "Show Ages in Joint Chart: " + form.preferences.ShowAgesInJoint + "<br />"
      s += "Disclaimer: " + form.preferences.Disclaimer.substring(0, 40) + "...<br />"


    } else {
      s = "None"
    }
    return s
  }

  const subData = () => {
    let s = ""
    if (form) {
      s = "Clients: " + form.data.clients + "<br />"
      s += "Scenarios: " + form.data.scenarios + "<br />"
    } else {
      s = "None"
    }
    return s
  }


  // const subPDFBuild = () => {
  //   let s = "Custom PDF Report: "
  //   if (form && form.Pdf) {
  //     s += "" + form.Pdf.Custommized
  //   } else {
  //     s = "false"
  //   }
  //   s += "<br />"
  //   return s
  // }
  const onSubscription = () => { };

  const onClosePreferences = () => {
    setErrmsg_s("");
    setOpenPreferences(false);
    getInputData()
  }

  // const onClosePDFBuild = () => {
  //   setErrmsg_s("");
  //   setOpenPDFBuild(false);
  //   getInputData()
  // }
  return (
    <Container maxWidth="true">
      {form !== undefined && (
        <>
          <Stack sx={{ mx: 4, my: 4 }} spacing={2}>
            <Stack direction="row" sx={{ mb: 6 }} spacing={2}>
              {/* <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              navigate("/selectClients");
            }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={onSubmit}>
            Submit
          </Button> */}
            </Stack>
            <Stack spacing={4}>
              <Stack direction="row" spacing={2} sx={{ justifyContent: "center" }}>
                <CardCommon title="Basic Profile" body={subBasic()} />
                <CardCommon title="Credentials" body={subCredentials()} />
                <CardCommon
                  title="Subscription"
                  body={subSubscriptions()}
                  onClick={() => {
                    setOpenSubscription(true);
                  }}
                />



              </Stack>

              <Stack direction="row" spacing={2} sx={{ justifyContent: "center" }}>
                <CardCommon title="Statistics" body={subStatistics()} />
                <CardCommon title="Preferences"
                  body={subPreferences()}
                  onClick={() => { setOpenPreferences(true); }}
                />
                <CardCommon title="Data"
                  body={subData()}
                  onClick={() => { setOpenData(true); }}
                />
              </Stack>
              <Stack direction="row" spacing={2} sx={{ justifyContent: "center" }}>
                {/* <CardCommon title="PDF Report Template"
                  body={subPDFBuild()()}
                  onClick={() => { setOpenPDFBuild(true); }}
                /> */}
              </Stack>
            </Stack>
          </Stack>

          <Subscribe
            open={openSubscription}
            onClose={() => {
              setOpenSubscription(false);
            }}
            subscription={subTier()}
            count={subCount()}
          />
          <ProfilePreferences
            form={form ? form.preferences : null}
            open={openPreferences}
            onClose={() => { onClosePreferences() }}
            onChange={onChange}
            onSubmit={onSubmit}
            errmsg={errmsg_s}
          />
          <ProfileData
            form={form ? form.data : null}
            open={openData}
            onClose={() => { setOpenData(false); }}
          />
          {/* {admin && (
            <PdfBuild
              open={openPDFBuild}
              onClose={() => { onClosePDFBuild() }}
              onChange={onChange}
              onSubmit={onSubmit}
            />
          )} */}
        </>
      )
      }
      <ErrorBar error={errmsg} />
      <Help_Profile />
    </Container >
  );
};

export default ProfileInput;
